import BlockTypes, { HEADER_BLOCKS } from '../../../types/BlockTypes';

function isPreviousBlockAnEmptyCell(previousBlock) {
  return previousBlock && previousBlock.type === BlockTypes.TABLE_CELL && previousBlock.text === '';
}

function mergeStartBlockWithPreviousBlock(editor, startBlock, previousBlock) {
  var startText = editor.value.startText;
  editor.snapshotSelection();
  return editor.withoutNormalizing(function () {
    editor.removeNodeByKey(startBlock.key).replaceNodeByKey(previousBlock.key, startBlock).setNodeByKey(startBlock.key, {
      type: previousBlock.type,
      data: previousBlock.data
    }).moveTo(startText.key);
  });
}

export default function onBackspace(event, editor, next) {
  if (!editor.isAtStartOfBlock()) {
    return next();
  }

  var previousBlock = editor.value.document.getPreviousBlock(editor.value.startText.key); // If previous block is an empty cell, default behavior will be to delete it
  // We don't want this, we want the content of the current line to be put
  // inside previous cell

  if (isPreviousBlockAnEmptyCell(previousBlock)) {
    event.preventDefault();
    return mergeStartBlockWithPreviousBlock(editor, editor.value.startBlock, previousBlock);
  } // First we try to de-indent a line


  if (editor.isIndented() && editor.canChangeDepth()) {
    event.preventDefault();
    return editor.changeDepth(-1);
  } // If block is already default, do nothing


  if (editor.isDefaultBlock()) {
    return next();
  }

  var startBlock = editor.value.startBlock;
  var parentBlock = editor.value.document.getFurthestBlock(startBlock.key); // If we are inside code block, a backspace should go back to the line before instead of resetting the block

  if (parentBlock && parentBlock.type === BlockTypes.CODES && !editor.isAtStartOfBlock(parentBlock)) {
    return next();
  }

  if (!HEADER_BLOCKS.includes(startBlock.type) || editor.isEmptyBlock()) {
    event.preventDefault();
    return editor.resetBlocks();
  }

  return next();
}